// extracted by mini-css-extract-plugin
module.exports = {"noteContainer":"Note_noteContainer__hCAeW","edit":"Note_edit__3Auf6","delete":"Note_delete__QL2mG","save":"Note_save__2pxsp"};